// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MXjC","buttons":"styles_buttons__18azB"};